import { render } from "./doctorWork.vue?vue&type=template&id=1b4df36e&scoped=true"
import script from "./doctorWork.vue?vue&type=script&lang=js"
export * from "./doctorWork.vue?vue&type=script&lang=js"

import "./doctorWork.vue?vue&type=style&index=0&id=1b4df36e&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4df36e"]])

export default __exports__